import {
  Box,
  Button,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Text,
  Tabs,
  VStack,
} from "@chakra-ui/react";
import { PayBillFormFields } from "./PayBillFormFields";

export const PayBillFormTabs = ({
  billItems,
  selectedTabIndex,
  handleTabChange,
  submitCurrentForm,
  pendingPayment,
  retryCountdownSeconds = 0,
  onVerifyPending,
  onProceedToCheckout,
  isVerifyPending,
  isSubmitLoading,
  getSubmitDisabled,
  formFieldsProps,
}) => {
  return (
    <Tabs variant="line" index={selectedTabIndex} onChange={handleTabChange}>
      <Box
        overflowX="auto"
        mb="14px"
        sx={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <TabList borderRadius="8px" p="4px" minW="max-content">
          {billItems.map((item) => (
            <Tab
              key={item}
              borderRadius="6px"
              fontSize="14px"
              fontWeight="600"
              textTransform="capitalize"
              flexShrink={0}
            >
              {item}
            </Tab>
          ))}
        </TabList>
      </Box>

      {Boolean(pendingPayment) && (
        <Box
          mb="14px"
          border="1px solid"
          borderColor="yellow.300"
          bg="yellow.50"
          borderRadius="8px"
          p="12px"
        >
          <Text fontSize="13px" color="yellow.800" mb="8px">
            {retryCountdownSeconds > 0
              ? `You have a pending VTU payment. Proceed to checkout and you will be auto-verified on return. You can start a new purchase in ${retryCountdownSeconds}s.`
              : "You still have a pending VTU payment. Proceed to checkout and you will be auto-verified on return; webhook will finalize the payment."}
          </Text>
          <HStack spacing="8px" flexWrap="wrap">
            <Button
              size="sm"
              colorScheme="primary"
              onClick={onProceedToCheckout}
              isDisabled={isVerifyPending}
              isLoading={isVerifyPending}
            >
              Continue Checkout
            </Button>
          </HStack>
        </Box>
      )}

      <TabPanels>
        {billItems.map((item) => (
          <TabPanel key={item} px={0}>
            <VStack
              margin={"auto"}
              w={["100%", "70%"]}
              spacing="14px"
              align="stretch"
            >
              <PayBillFormFields item={item} {...formFieldsProps} />
              <Button
                onClick={submitCurrentForm}
                isLoading={isSubmitLoading}
                isDisabled={getSubmitDisabled(item)}
              >
                Submit
              </Button>
            </VStack>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};
